/*=========================================================================================
  File Name: module-confirm-business.js
  Description: Confirm Business Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-confirm-business-state';
import mutations from './module-confirm-business-mutations';
import actions from './module-confirm-business-actions';
import getters from './module-confirm-business-getters';

export default {
    debug: process.env.NODE_ENV !== 'production',
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};